import Resumen from '@/models/Resumen';
import Comprobante from '@/models/Comprobante';
import Grano from '@/models/Grano';
import Cosecha from '@/models/Cosecha';
import TipoComprobante from '@/models/TipoComprobante';
import ValorGrano from '@/models/TipoComprobante';
import Total from '@/models/Total';
import axios from 'axios';
function defaultState() {
	return {
		valoresdegranos: [],
		resumenes: [],
		tableData: [],
		tipocomprobantes: [],
		tipoctasctes: [],
		valores: [],
		granos: [],
		cosechas: [],
		totales: [],
		primergrano: 1,
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setValoresDeGranos(state: { valoresdegranos: ValorGrano[] }, valores: ValorGrano[]) {
		state.valoresdegranos = valores;
	},
	setResumenes(state: { resumenes: Resumen[] }, resumenes: Resumen[]) {
		state.resumenes = resumenes;
	},
	setTableDataGranos(state: { tableData: Comprobante[] }, data: Comprobante[] | Comprobante) {
		!Array.isArray(data) ? state.tableData.push(data) : (state.tableData = []);
	},
	setTipoDeComprobantes(state: { tipocomprobantes: TipoComprobante[] }, tcomprobantes: TipoComprobante[]) {
		state.tipocomprobantes = tcomprobantes;
	},
	setTipoDeCtasCtes(state: { tipoctasctes: [] }, tctasctes: []) {
		state.tipoctasctes = tctasctes;
	},
	setTotales(state: { totales: Total[] }, totales: Total[]) {
		state.totales = totales;
	},
	setCosechas(state: { cosechas: Cosecha[] }, cosechas: Cosecha[]) {
		state.cosechas = cosechas;
	},
	setGranos(state: { granos: Grano[] }, granos: Grano[]) {
		state.granos = granos;
	},
	setPrimerGrano(state: { primergrano: number }, primer: number) {
		state.primergrano = primer;
	},
};
const actions = {
	async callResumenGranos({ commit }, params: { data: object; start: number; limit: number }): Promise<Comprobante[]> {
		const r = await axios
			.get(`./api/public/proxy/cgi/etenet_fichadet?start=${params.start}&limit=${params.limit}`, params.data)
			.then(response => {
				if (response.data.items) {
					response.data.items.forEach((element: Comprobante) => {
						//TODO: codigo necesario cuando se pase formato a tablas.
						//var dateParts = element.fecha.split('-');
						//element.fecha = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
						commit('setTableDataGranos', element);
					});
				}
				commit('setGranos', response.data.granos as Grano[]);
				commit('setResumenes', response.data.resumenes as Resumen[]);
				commit('setValoresDeGranos', response.data.valoresdegranos ? (response.data.valoresdegranos as ValorGrano[]) : []);
				commit('setCosechas', response.data.cosechas as Cosecha[]);
				commit('setTipoDeComprobantes', response.data.tipodecomprobantes as TipoComprobante[]);
				commit('setTotales', response.data.totales[0] as Total);
				if (response.data.granos) commit('setPrimerGrano', response.data.granos[0].grano as Grano);
				return response.data.items;
			});
		return r;
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
